import React = require("react");
import format = require("string-format");
import {Buttons} from "../../../../../components/buttons/Buttons";

interface PageLoaderProps {
    currentPage: number;
    totalPages: number;
    changePage: (page: number) => void;
    pageText: string;
}

export class PageLoader extends React.Component<PageLoaderProps, any> {

    constructor(props: PageLoaderProps) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
    }

    public render() {
        if (this.props.totalPages == null || this.props.totalPages <= 1) {
            return null;
        }
        /*return (
            <div className="page-loader">
                <div className="page-button prev-page-button" onClick={this.prevPage}>
                    <p>&lt;</p>
                </div>
                {this.renderPagesSelect()}
                <div className="page-button next-page-button" onClick={this.nextPage}>
                    <p>&gt;</p>
                </div>
            </div>
        );*/
        return (
            <div className="page-loader">
                <Buttons.ButtonWithIcon
                    icon={"./images/buttons/icon-previous.png"}
                    key={"back"}
                    variant={"tertiary"}
                    invertIconColor={false}
                    onClick={this.prevPage}
                    code={"back"}
                    selected={false}
                />
                {this.renderPagesSelect()}
                <Buttons.ButtonWithIcon
                    icon={"./images/buttons/icon-next.png"}
                    key={"next"}
                    variant={"tertiary"}
                    onClick={this.nextPage}
                    invertIconColor={false}
                    code={"next"}
                    selected={false}
                />
            </div>
        );
    }

    private nextPage() {
        if (this.props.totalPages > this.props.currentPage + 1) {
            this.props.changePage(this.props.currentPage + 1);
        }
    }

    private prevPage() {
        if (this.props.currentPage - 1 >= 0) {
            this.props.changePage(this.props.currentPage - 1);
        }
    }

    private renderPagesSelect() {
        const renderOptions = () => {
            const options = [];
            for (let i = 0; i < this.props.totalPages; i++) {
                options.push(
                    (
                        <option
                            value={"" + i}
                            key={i}
                        >
                            {format(this.props.pageText, i + 1)} / {this.props.totalPages}
                        </option>
                    ),
                );
            }
            return options;
        };
        const change = (e) => {
            console.log(e);
            this.props.changePage(parseInt(e.target.value, 10));
        };
        return (
            <select className={"page-select"} value={"" + this.props.currentPage} onChange={change}>
                {renderOptions()}
            </select>
        );
    }
}
